/**
 * API base URL from environment (.env / deployment config).
 * Change REACT_APP_API and restart the app (dev server or production build) to apply.
 */
const rawApiUrl = process.env.REACT_APP_API?.trim();

if (!rawApiUrl) {
    throw new Error(
        'REACT_APP_API is not set. Add REACT_APP_API to your .env file and restart the application.'
    );
}

export const API_BASE_URL = rawApiUrl.replace(/\/$/, '');

/**
 * Resolve a relative media path against the configured API base URL.
 * @returns {string|null}
 */
export function resolveMediaUrl(imagePath) {
    if (imagePath == null || imagePath === '') return null;
    const trimmed = String(imagePath).trim();
    if (!trimmed) return null;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (trimmed.startsWith('//')) return `https:${trimmed}`;
    const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return `${API_BASE_URL}${path}`;
}

export default API_BASE_URL;
